import React, { useEffect, useContext, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import API from "../../Service/Baseservice";
import "jspdf-autotable";
import dayjs from "dayjs";
import moment from "moment-timezone";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { useLocation } from "react-router-dom";
import UploadIcon from "../../../Assets/img/upload.png";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Download from "../../../Assets/img/download.svg";
import Delete from "../../../Assets/img/Delete.svg";
import { format, formatDistanceStrict } from "date-fns";
import Loading from "../../../Loading/loading";
import { useRef } from "react";

const ConsultationEdit = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [admin, setAdmin] = useState(null);
    const [step, setStep] = useState(1);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const pageNumber = location.state?.pageNumber || 1;
    const languageId = location.state?.language_id || 1;
    const getExt = (url) => url.split(".").pop().toLowerCase();
    const [startDate, setStartDate] = React.useState(dayjs());
    const [newStartDate, setNewStartDate] = React.useState(dayjs());
    const [startTime, setStartTime] = useState("");
    const [immigrationErr, setImmigrationErr] = useState("");
    const [consultationErr, setConsultationErr] = useState("")
    const [timeErr, setTimeErr] = useState("");
    const [endTime, setEndTime] = useState("")
    const [hadleType, setHandleType] = useState("")
    const [activeStartTime, setActiveStartTime] = useState(null);
    const [immigrationvalue, setimmigration] = useState()
    const [consultationtype, setConsultationType] = useState("");
    const [listimmigratongoal, setImmigrationGoal] = useState("")
    const [timeList, setTimeList] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [personalInfo, setPersonalInfo] = useState({});
    const [backgroundInfo, setBackgroundInfo] = useState({});
    const [paymentInfo, setPaymentInfo] = useState({});
    const [documents, setDocuments] = useState({});
    const [signatureDoc, setSignatureDoc] = useState(null);
    const [countryCode, setCountryCode] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [flag, setFlag] = useState(false);

    const [personalinformation, setPersonalInformation] = useState([]);
    const [bagroundinformation, setBagroundInformation] = useState([])
    const [documentupload, setDocumentUpload] = useState([])
    const [paymentinformation, setPaymentInformation] = useState([])
    const [uploadedFiles, setUploadedFiles] = useState({})
    const [signaturedocument, setSignatureDocument] = useState("")

    const safePersonalInformation = Array.isArray(personalinformation) ? personalinformation : [];
    const safeBackgroundInformation = Array.isArray(bagroundinformation) ? bagroundinformation : [];
    const safeDocumentUpload = Array.isArray(documentupload) ? documentupload : [];
    const safePaymentInformation = Array.isArray(paymentinformation) ? paymentinformation : [];
    const normalizeTime = (time) => {
        if (!time) return "";
        return time.length === 5 ? time : time.slice(0, 5);
    };

    const normalizeDate = (date) => {
        if (!date) return "";

        if (typeof date === "string") {
            return date.slice(0, 10);
        }

        if (dayjs.isDayjs(date)) {
            return date.format("YYYY-MM-DD");
        }

        return dayjs(date).format("YYYY-MM-DD");
    };


const normalize = (str = "") => {
    if (!str || typeof str !== "string") return "";
    return str
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/\u00a0/g, " ")
        .replace(/\s+/g, " ")
        .trim();
};

    const [popup, setPopup] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });
    const [popupbutton, setPopupbutton] = useState({
        show: false,
        title: "",
        message: "",
        type: "info",
    });

    const [paymentMessage, setPaymentMessage] = useState("");
    const [paymentImageUrl, setPaymentImageUrl] = useState(null);
    const [paymentImagePreview, setPaymentImagePreview] = useState(null);
    const [appointmentAmount, setAppointmentAmount] = useState("");
    const [amountReceived, setAmountReceived] = useState(false);
    const [paymentErrors, setPaymentErrors] = useState({});
    const [bookingErrors, setBookingErrors] = useState({});
    const [showNotesPopup, setShowNotesPopup] = useState(false);
    const [notesText, setNotesText] = useState("");
    const [notesError, setNotesError] = useState("");
    const [showNotesList, setShowNotesList] = useState(false);
    const [notesList, setNotesList] = useState([]);
    const [notesListLoading, setNotesListLoading] = useState(false);
    const amountStatus = admin?.paymentrequest?.[0]?.amount_status;


    /* ================= FETCH DATA ================= */
    useEffect(() => {
        if (!id) return;

        API.post("ConsultationCustomerViewEdit/condition", {
            consultation_booking_id: id,
        })
            .then((res) => {
                const row = res.data?.data?.data?.[0];
                setAdmin(row || null);
            })
            .catch((err) => console.error("View error:", err))
            .finally(() => setLoading(false));
    }, [id]);
    useEffect(() => {
        if (!admin) return;

        setHandleType(admin.consultation_type_id);
        setimmigration(admin.listofservice_id);

        if (admin.admin_date) {
            setStartDate(dayjs(admin.admin_date));
        }

        setStartTime(admin.start_time);
        setEndTime(admin.end_time);
        setActiveStartTime(admin.admin_start_time);

    }, [admin]);
    useEffect(() => {
        if (!admin) return;

        setPersonalInfo(admin.customer || {});
        setBackgroundInfo(admin.background || {});
        setPaymentInfo(admin.payment || {});
        setDocuments(admin.document || {});
        setSignatureDoc(admin.signature_document || null);
    }, [admin]);
    useEffect(() => {
        if (startDate && hadleType) {
            bookingList();
        }
    }, [startDate, hadleType]);
    useEffect(() => {
        if (id) {
            webListOfService()
            consultationType()

        }
    }, [id])
    const consultationType = () => {
        let req = {
            language_id: languageId
        }
        API.post("consultationTypelist/webCondition", req).then((res) => {
            if (res.data.success === true) {
                setConsultationType(res.data.data)

            }
        })

    }
    const webListOfService = () => {
        setLoading(true);
        let req = {
            language_id: languageId
        }
        API.post("weblistofservice_list/webCondition", req).then((res) => {
            if (res.data.success === true) {
                setImmigrationGoal(res.data.data.data)
                setLoading(false);
            }
        })
    }
    useEffect(() => {
        if (hadleType && startDate) {
            fetchTimeList(startDate.format("YYYY-MM-DD"));
        }
    }, [hadleType, startDate]);
    const fetchTimeList = (selectedDate) => {
        let req = {
            consultation_type_id: hadleType,
            consultation_date: selectedDate,
            user_timezone: "America/Toronto"
        };
        API.post("consultationTimerSlotslist/webCondition", req)
            .then((res) => {
                if (res.data.success === true) {
                    setTimeList(res.data.data);
                } else {
                    setTimeList([]);
                }
            })
            .catch((err) => {
                console.error("Error fetching time slots:", err);
                setTimeList([]);
            });
    };
    const [bookedRanges, setBookedRanges] = useState([]);

    const bookingList = () => {
        setBookedRanges([]);
        let req = {
            booking_date: startDate ? startDate.format("YYYY-MM-DD") : null,
            user_timezone: "America/Toronto"

        };
        API.post("consultationBokkinglist/webCondition", req).then((res) => {
            if (res.data.success && Array.isArray(res.data.data)) {

                if (res.data.data.length === 0) {
                    setBookedRanges([]);
                    return;
                }
                const ranges = res.data.data.map(item => ({
                    start: toMinutes(item.start_time),
                    end: toMinutes(item.end_time),
                    bookingId: item.consultation_booking_id

                }));
                setBookedRanges(ranges);
            } else {
                setBookedRanges([]);
            }
        });
    };
    const isSlotDisabled = (slotStart, slotEnd) => {
        if (!slotStart || !slotEnd) return false;
        if (
            normalizeTime(slotStart) === normalizeTime(admin?.start_time) &&
            normalizeTime(slotEnd) === normalizeTime(admin?.end_time)
        ) {
            return false;
        }
        const start = toMinutes(slotStart);
        const end = toMinutes(slotEnd);

        return bookedRanges.some(b => {
            if (b.bookingId === admin?.consultation_booking_id) {
                return false;
            }

            return start < b.end && end > b.start;
        });
    };
    const toMinutes = (time) => {
        if (!time) return 0;
        const [h, m] = time.slice(0, 5).split(":");
        return Number(h) * 60 + Number(m);
    };
    const formatTime = (time) => time?.slice(0, 5);
    const convertTimezone = (item) => {
        const toTZ = admin?.user_timezone || "America/Toronto";

        const start = moment.tz(
            `${item.user_date} ${item.start_time}`,
            "YYYY-MM-DD HH:mm:ss",
            "America/Toronto"
        );

        const end = moment.tz(
            `${item.user_date} ${item.end_time}`,
            "YYYY-MM-DD HH:mm:ss",
            "America/Toronto"
        );

        return {
            startDate: start.clone().tz(toTZ).format("YYYY-MM-DD"),
            startTime: start.clone().tz(toTZ).format("HH:mm:ss"),
            endDate: end.clone().tz(toTZ).format("YYYY-MM-DD"),
            endTime: end.clone().tz(toTZ).format("HH:mm:ss")
        };
    }
    const handleStartTime = (item) => {
        if (!item) return;
        setActiveStartTime(item.start_time);
        setFlag(true);
        setStartTime(convertTimezone(item).startTime);
        setEndTime(convertTimezone(item).endTime);
        setNewStartDate(convertTimezone(item).startDate);
        setTimeErr("");
    };
    const handleConsultationType = (e) => {
        setHandleType(e.target.value);
    }
    const calendarStyles = {
        width: "100%",
        maxWidth: "100%",
        overflow: "hidden",


        "& .MuiPickersCalendarHeader-root": {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 12px",
            marginBottom: "8px",
            position: "relative",
        },
        "& .MuiPickersCalendarHeader-labelContainer": {
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            pointerEvents: "none",
        },
        "& .MuiPickersCalendarHeader-label": {
            fontSize: "18px",
            fontWeight: 600,
        },
        "& .MuiPickersArrowSwitcher-root": {
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
        },
        "& .MuiPickersArrowSwitcher-button": {
            width: "36px",
            height: "36px",
            borderRadius: "50%",
            backgroundColor: "#F1F3F4",
        },
        "& .MuiPickersArrowSwitcher-button:hover": {
            backgroundColor: "#E3E5E5",
        },
        "& .MuiDayCalendar-weekDayLabelContainer": {
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            width: "100%",
        },
        "& .MuiDayCalendar-weekDayLabel": {
            width: "100%",
            textAlign: "center",
            fontSize: "14px",
            fontWeight: 500,
        },
        "& .MuiDayCalendar-weekContainer": {
            display: "grid",
            gridTemplateColumns: "repeat(7, 1fr)",
            width: "100%",
            justifyItems: "center",
        },
        "& .MuiPickersDay-root": {
            width: "40px",
            height: "40px",
            margin: "auto",
            fontSize: "21px",
            borderRadius: "50%",
            backgroundColor: "transparent",
            border: "none",
        },
        "& .MuiPickersDay-root.Mui-selected": {
            backgroundColor: "#E3E5E5",
            color: "#72777A",
            border: "none",
        },
        "& .MuiPickersDay-root.Mui-selected:focus": {
            backgroundColor: "#E3E5E5",
            outline: "none",
        },
        "& .MuiPickersDay-root:focus": {
            backgroundColor: "transparent",
            outline: "none",
        },
        "& .MuiPickersDay-root:hover": {
            backgroundColor: "#E3E5E5",
            border: "none",
        },
        "& .MuiPickersDay-dayOutsideMonth": {
            visibility: "hidden",
        },
        "& .MuiPickersSlideTransition-root": {
            overflow: "hidden",
        },
    };
    const Immigration = (e) => {
        const value = e.target.value
        setimmigration(value)
    }
    useEffect(() => {
        preferedlanguagedropdown()
        countryDropDownService()
    }, [])
    const [bgDropdownData, setBgDropdownData] = useState({});
    const fetchBackgroundDropdown = (backgroundInformationId) => {
        API.post("backgroundInformationDataDropDown/webCondition", {
            background_information_id: backgroundInformationId
        })
            .then((res) => {
                if (res.data?.success && Array.isArray(res.data.data)) {
                    setBgDropdownData((prev) => ({
                        ...prev,
                        [backgroundInformationId]: res.data.data
                    }));
                }
            })
            .catch(console.error);
    };


    useEffect(() => {
        bagroundinformation?.forEach((item) => {
            const label = normalize(item.label);

            if (
                [
                    "what is your primary for immigration to canada?",
                    "quel est votre principal motif d'immigration au canada ?"
                ].includes(label)
            ) {
                fetchBackgroundDropdown(item.background_information_id);
            }
        });
    }, [bagroundinformation]);

    const [preferedlanguage, setPreferedLanguage] = useState("")
    const preferedlanguagedropdown = () => {
        API.post("preferedLanguagesDropdown/webCondition").then((res) => {
            if (res.data.success === true) {
                setPreferedLanguage(res.data.data)

            }
        })
    }
    const [activeCountryType, setActiveCountryType] = useState(null);
    const [countryDropDown, setCountryDropDown] = useState([]);

    const countryDropDownService = () => {
        API.post("countryDropdown/webCondition", {
            language_id: languageId
        })
            .then((res) => {
                if (res.data.success === true) {
                    setCountryDropDown(res.data.data);
                }
            })
            .catch((err) => {
                console.error("Country dropdown error:", err);
            });
    };
    const buildPersonalPayload = () => {
        return {
            customer_personal_information_id: admin.customer_personal_information_id,

            personal_information_id: safePersonalInformation.map(
                (item) => item.personal_information_id
            ),

            customer_personal_informations_details: safePersonalInformation.map(
                (item) => personalInformationValues[item.personal_information_id] ?? ""
            ),
        };
    };


    const buildBackgroundPayload = () => {
        return {
            background_information_details_id: admin.background_information_details_id,

            background_information_id: safeBackgroundInformation.map(
                (item) => item.background_information_id
            ),

            details: safeBackgroundInformation.map(
                (item) => bagroundinformationvalues[item.background_information_id] ?? ""
            ),
        };
    };
    const buildPaymentPayload = () => {
        return {
            payment_information_details_id: admin.payment_information_details_id,

            payment_information_id: safePaymentInformation.map(
                (item) => item.payment_information_id
            ),
            payment_details: safePaymentInformation.map(
                (item) => paymentInformationValues[item.payment_information_id] ?? ""
            ),
        };
    };
    const buildDocumentPayload = () => {
        return {
            document_upload_details_id: admin.document_upload_details_id,

            document_upload_id: safeDocumentUpload.map(
                (item) => item.document_upload_id
            ),
            document_details: safeDocumentUpload.map((item) => {
                const files = uploadedFiles[item.document_upload_id] || [];
                return files.map((f) => f.url);
            }),
        };

    };
    const handleNextStep = () => {
        let hasError = false;

        if (!immigrationvalue) {
            setImmigrationErr(
                languageId === 1
                    ? "Please select immigration goal"
                    : "Veuillez sélectionner l'objectif d'immigration"
            );
            hasError = true;
        } else {
            setImmigrationErr("");
        }

        if (!hadleType) {
            setConsultationErr(
                languageId === 1
                    ? "Please select consultation type"
                    : "Veuillez sélectionner le type de consultation"
            );
            hasError = true;
        } else {
            setConsultationErr("");
        }

        if (!startDate) {
            hasError = true;
        }

        if (!startTime || !endTime) {
            setTimeErr(
                languageId === 1
                    ? "Please select a time slot"
                    : "Veuillez sélectionner une plage horaire"
            );
            hasError = true;
        } else {
            setTimeErr("");
        }

        if (hasError) return;

        setStep(2);
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    const validatePersonalInformation = () => {
        let errors = {};
        let isValid = true;

        personalinformation.forEach((item) => {
            const value = personalInformationValues[item.personal_information_id];
            const label = item.label?.toLowerCase();

            const isEmail =
                label?.includes("email") ||
                label?.includes("e-mail");

            // Required check
            if (value === undefined || value === null || value === "") {
                errors[item.personal_information_id] = `${item.label} is required`;
                isValid = false;
                return;
            }

            // Email format check
            if (isEmail && !emailRegex.test(value)) {
                errors[item.personal_information_id] = "Please enter a valid email address";
                isValid = false;
            }
        });

        setPersonalInformationErr(errors);
        return isValid;
    };


    const validateBackgroundInformation = () => {
        let errors = {};
        let isValid = true;

        bagroundinformation.forEach((item) => {
            const value = bagroundinformationvalues[item.background_information_id];
            const label = item.label;

            // Optional field example (timeline in your UI)
            const isTimeline =
                normalize(label) === normalize("What timeline are you targeting?") ||
                normalize(label) === normalize("Quel est votre objectif en termes de calendrier ?");

            if (isTimeline) return;

            if (!value || value.toString().trim() === "") {
                errors[item.background_information_id] = `${label} is required`;
                isValid = false;
            }
        });

        setBagroundInformationErr(errors);
        return isValid;
    };
    const handleUpdateConsultation = async () => {
        const isPersonalValid = validatePersonalInformation();
        const isBackgroundValid = validateBackgroundInformation();

        if (
            !isPersonalValid ||
            !isBackgroundValid
        ) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            return;
        }
        try {
            const payload = {
                ...buildPersonalPayload(),
                ...buildBackgroundPayload(),
                ...buildDocumentPayload(),
                ...buildPaymentPayload(),
                language_id: languageId,
                consultation_booking_id: Number(id),
                consultation_type_id: Number(hadleType),
                listofservice_id: Number(immigrationvalue),
                booking_date: flag ? newStartDate : startDate.format("YYYY-MM-DD"),
                start_time: startTime,
                end_time: endTime,
                signature_document: isSignatureRemoved ? null
                    : signatureUrl || admin.signature_document,
                user_timezone: admin.user_timezone,
            };

            const res = await API.post("userConsultationUpdate/update", payload);
            if (res.data.success) {
                setPopup({
                    show: true,
                    title: "Success",
                    message: "Consultation updated successfully",
                    type: "success",
                });
            } else {
                setPopup({
                    show: true,
                    title: "Error",
                    message:
                        res.data?.message ||
                        "Update failed. Please try again.",
                    type: "error",
                });
            }
        } catch (error) {
            console.error("❌ Update failed", error);

            setPopup({
                show: true,
                title: "Error",
                message:
                    error?.response?.data?.message ||
                    "Something went wrong while updating the consultation.",
                type: "error",
            });
        }
    };


const normalizeKey = (str = "") => {
  if (!str || typeof str !== "string") return "";  // ← add this
  return str.toLowerCase().trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};


    useEffect(() => {
        if (!admin || !personalinformation.length || !countryDropDown.length) return;

        const customerMap = {};
        Object.entries(admin.customer || {}).forEach(([k, v]) => {
            customerMap[normalizeKey(k)] = v;
        });

        const values = {};

        personalinformation.forEach((item) => {
            const normalizedLabel = normalizeKey(item.label);
            const value = customerMap[normalizedLabel];

            if (value === undefined || value === null) return;

            const inputType = normalizeKey(item.input_type);
            const id = item.personal_information_id;

            const isMobile =
                inputType.includes("mobile_number") ||
                inputType.includes("numero_de_portable");

            if (isMobile) {
                const cleaned = String(value).replace(/\s+/g, "");

                const sortedCountries = [...countryDropDown].sort(
                    (a, b) =>
                        (b.dial_code || "").length - (a.dial_code || "").length
                );

                const matchedCountry = sortedCountries.find((c) => {
                    const code =
                        c.dial_code ||
                        c.country_code ||
                        c.dialCode ||
                        "";
                    const formatted = code.startsWith("+") ? code : `+${code}`;
                    return cleaned.startsWith(formatted);
                });

                if (matchedCountry) {
                    const code =
                        matchedCountry.dial_code ||
                        matchedCountry.country_code ||
                        matchedCountry.dialCode ||
                        "";
                    const formattedCode = code.startsWith("+") ? code : `+${code}`;
                    const numberOnly = cleaned.replace(formattedCode, "");

                    setCountryCode(formattedCode);
                    setMobileNumber(numberOnly);
                }

                values[id] = cleaned;
            } else {
                values[id] = value;
            }
        });

        setpersonalInformationValues(values);
    }, [admin, personalinformation, countryDropDown]);

    useEffect(() => {
        if (!admin || !bagroundinformation) return;

        const normalize = (str) =>
            str?.trim().toLowerCase().replace(/\s+/g, " ");

        const map = {};
        bagroundinformation.forEach(item => {
            map[normalize(item.label)] = item.background_information_id;
        });

        const values = {};
        Object.entries(admin.background || {}).forEach(([label, value]) => {
            const key = map[normalize(label)];
            if (key) values[key] = value;
        });

        setbagroundInformationValues(values);
    }, [admin, bagroundinformation]);

    useEffect(() => {
        if (!admin || !paymentinformation) return;
        const map = {};
        paymentinformation.forEach(item => {
            map[item.label.trim().toLowerCase()] = item.payment_information_id;
        });
        const values = {};
        Object.entries(admin.payment || {}).forEach(([label, value]) => {
            const key = map[label.trim().toLowerCase()];
            if (key) values[key] = value;
        });
        setPaymentInformationValues(values);
    }, [admin, paymentinformation]);
    useEffect(() => {
        if (!admin || !documentupload) return;

// Replace the direct fetch with API call
const loadFiles = async () => {
    const uploaded = {};

    for (const item of documentupload) {
        const raw = admin.document?.[item.label];
        if (!raw) continue;

        const urls = typeof raw === "string" ? JSON.parse(raw) : raw;

        uploaded[item.document_upload_id] = await Promise.all(
            urls.map(async (url) => {
                const isPdf = url.toLowerCase().endsWith(".pdf");

                if (isPdf) {
                    try {
                        // Use your backend API to proxy the file
                        const response = await API.post("fileProxy/get", { 
                            fileUrl: url 
                        });
                        
                        // Assuming the API returns the file as blob or base64
                        // You'll need to adjust based on your API response format
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        return {
                            url,
                            preview: URL.createObjectURL(blob),
                            type: "application/pdf",
                        };
                    } catch (error) {
                        console.error("Error fetching PDF:", error);
                        // Fallback to direct URL (will show error but not crash)
                        return {
                            url,
                            preview: url,
                            type: "application/pdf",
                        };
                    }
                }

                return {
                    url,
                    preview: url,
                    type: url.endsWith(".txt")
                        ? "text/plain"
                        : "image/*",
                };
            })
        );
    }

    setUploadedFiles(uploaded);
};

        loadFiles();
    }, [admin, documentupload]);

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (err) => reject(err);
        });
    };
    const handleFileChange = async (id, e) => {
        const files = Array.from(e.target.files);
        if (!files.length) return;

        for (const file of files) {
            console.log("Uploading file:", file);
            const previewUrl = URL.createObjectURL(file);
            const base64Data = await fileToBase64(file);
            const isDocument = [
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.ms-excel",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            ].includes(file.type);
            const finalBase64 = isDocument ? base64Data.split(",")[1] : base64Data;
            const req = {
                name: "My Document",
                document: [
                    {
                        name: file.name,
                        type: file.type,
                        base64: finalBase64,
                        size: file.size,
                    },
                ],
            };
            try {
                const res = await API.post("imageUpload/add", req);
                setUploadedFiles(prev => ({
                    ...prev,
                    [id]: [
                        ...(prev[id] || []),
                        {
                            name: file.name,
                            type: file.type,
                            preview: previewUrl,
                            url: res.data.url?.[0],
                        }
                    ],
                }));
            } catch (err) {
                console.error("Upload error:", err.response?.data || err.message);
            }
        }
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (id, e) => {
        e.preventDefault();

        const files = e.dataTransfer.files;
        if (!files || !files.length) return;


        const fakeEvent = {
            target: { files },
        };

        handleFileChange(id, fakeEvent);
    };
    const [signaturePreview, setSignaturePreview] = useState(null);
    const [signatureUrl, setSignatureUrl] = useState(null);
    const [signatureType, setSignatureType] = useState(null);
    const signatureInputRef = useRef(null);
    const [isSignatureRemoved, setIsSignatureRemoved] = useState(false);

    const handleSignatureUpload = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setSignatureType(file.type);
        setSignatureName(file.name);

        const previewUrl = URL.createObjectURL(file);
        setSignaturePreview(previewUrl);

        const base64 = await fileToBase64(file);

        const req = {
            name: "Signature",
            document: [
                {
                    name: file.name,
                    type: file.type,
                    base64: base64,
                },
            ],
        };

        API.post("imageUpload/add", req)
            .then((res) => {
                const uploadedUrl = res.data.url?.[0];
                if (uploadedUrl) {
                    setSignatureUrl(uploadedUrl);
                }
            })
            .catch((err) =>
                console.error("Signature upload error:", err.response?.data || err.message)
            );
    };

    useEffect(() => {
        if (!admin?.signature_document || admin.signature_document === "null") return;

        let active = true;

        const loadSignature = async () => {
            const url = admin.signature_document;

            if (url.toLowerCase().endsWith(".pdf")) {
                const res = await fetch(url);
                const blob = await res.blob();

                if (!active) return;
                setSignaturePreview(URL.createObjectURL(blob));
                setSignatureType("application/pdf");
            } else {
                setSignaturePreview(url);
                setSignatureType("image/jpeg");
            }
        };

        loadSignature();

        return () => {
            active = false;
        };
    }, [admin]);

    useEffect(() => {
        return () => {
            if (signaturePreview?.startsWith("blob:")) {
                URL.revokeObjectURL(signaturePreview);
            }
        };
    }, [signaturePreview]);


    const { consultation_type_id, listofservice_id, bookingdate, starttime, endtime } = location.state || {};
    const [successPopup, setSuccessPopup] = useState(false)
    useEffect(() => {
        if (languageId) {
            formList()
        }
    }, [languageId])
    const [personalInformationValues, setpersonalInformationValues] = useState({})

    const [consent, setConsent] = useState("")
    const [signatureName, setSignatureName] = useState(null);
    const formList = () => {
        setLoading(true);
        let req = {
            language_id: languageId
        }
        API.post("consultationFormlistweb/webCondition", req).then((res) => {
            if (res.data.success === true) {
                setPersonalInformation(res.data.data.persnoalinformations)
                setBagroundInformation(res.data.data.backgroundinformation)
                setDocumentUpload(res.data.data.documentupload)
                setPaymentInformation(res.data.data.paymentinformation)
                setSignatureDocument(res.data.data.signaturedocument);
                setConsent(res.data.data.consent[0])
                setLoading(false);
            }
        })
    }
    const [bagroundinformationvalues, setbagroundInformationValues] = useState("")
    const handlePersonalInformation = (id, value) => {
        setpersonalInformationValues(prev => ({
            ...prev,
            [id]: value
        })
        )
    }
    const handleBagroundInformation = (id, value) => {
        setbagroundInformationValues(prev => ({
            ...prev,
            [id]: value
        }))
    }
    const [paymentInformationValues, setPaymentInformationValues] = useState("")
    const handlePaymentInformation = (id, value) => {
        const key = String(id);
        setPaymentInformationValues(prev => ({
            ...prev,
            [key]: value
        }));
        setPaymentInformationErr(prev => ({
            ...prev,
            [key]: ""
        }));
    };
    const [personalInformationErr, setPersonalInformationErr] = useState({})
    const [bagroundInformationErr, setBagroundInformationErr] = useState({})
    const [documentUploadErr, setDocumentUploadErr] = useState({});
    const [paymentInformationErr, setPaymentInformationErr] = useState({});
    const [ackError, setAckError] = useState("");
    const [isAgreed, setIsAgreed] = useState(false);

    useEffect(() => {
        preferedlanguagedropdown()
        countryDropDownService()
    }, [])
    const handleDateChange = (date) => {
        setStartDate(date);
        // setActiveStartTime(null);
        setStartTime("");
        setEndTime("");
    };

    useEffect(() => {
        if (!admin || !timeList.length || !startDate) return;

        const bookingDate = normalizeDate(admin.admin_date);
        const currentDate = normalizeDate(startDate);
        if (bookingDate === currentDate) {
            setActiveStartTime(admin.admin_start_time);
            setStartTime(admin.start_time);
            setEndTime(admin.end_time);
        } else {
            setActiveStartTime("");
            setStartTime("");
            setEndTime("");
        }
    }, [timeList, admin, startDate]);

    useEffect(() => {
        console.log("Active:", activeStartTime);
    }, [activeStartTime, timeList]);
    const [signatureFile, setSignatureFile] = useState(null);

    // const downloadDocument = (file) => {
    //     const win = window.open(file.url, "_blank");
    //     if (win) {
    //         setTimeout(() => win.close(), 200);
    //     }
    // };

const downloadDocument = async (file) => {
  try {
    const res = await fetch("https://qa-service.asraimmigration.ca/backend_service/v1/fileDownloadUrl/add", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        model: "fileDownloadUrl",
        key: new URL(file.url).pathname.substring(1)    ,
      }),
    });

    const data = await res.json();

    if (!data.status || !data.download_url) {
      throw new Error("Invalid download response");
    }

    // 🔥 THIS triggers download without new tab
    window.location.href = data.download_url;

  } catch (error) {
    console.error("Download failed:", error);
    setPopup({
      show: true,
      title: "Download Failed",
      message: "Unable to download file",
      type: "error",
    });
  }
};


    const removeDocument = (documentUploadId, index) => {
        setUploadedFiles(prev => {
            const updated = { ...prev };

            if (!updated[documentUploadId]) return prev;

            updated[documentUploadId] = updated[documentUploadId].filter(
                (_, i) => i !== index
            );

            if (updated[documentUploadId].length === 0) {
                delete updated[documentUploadId];
            }

            return updated;
        });
    };
    const downloadSignature = async () => {
        try {
            if (signatureFile instanceof File) {

                const blobUrl = URL.createObjectURL(signatureFile);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = signatureName || "signature";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
                return;
            }

            if (typeof signaturePreview === "string" && signaturePreview !== "null") {

                const response = await fetch(signaturePreview, { mode: "cors" });
                if (!response.ok) throw new Error("Failed to fetch signature");

                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);

                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = signatureName || "signature";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
                return;
            }

            throw new Error("Signature not available");
        } catch (error) {
            console.error("Download failed:", error);
            setPopup({
                show: true,
                title: "Download Failed",
                message: "Unable to download signature",
                type: "error",
            });
        }
    };

    const removeSignature = () => {
        if (signaturePreview?.startsWith("blob:")) {
            URL.revokeObjectURL(signaturePreview);
        }

        setSignaturePreview(null);
        setSignatureUrl(null);
        setSignatureType(null);
        setSignatureName(null);
        setIsSignatureRemoved(true);

        if (signatureInputRef.current) {
            signatureInputRef.current.value = "";
        }
    };

    const resetPopupFormData = () => {
        setPaymentMessage("");
        setPaymentImagePreview(null);
        setPaymentImageUrl("");
        setPaymentErrors({});

        setAppointmentAmount("");
        setAmountReceived(false);
        setBookingErrors({});
    };

    const handlePaymentImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setLoading(true);

        const preview = URL.createObjectURL(file);
        setPaymentImagePreview(preview);

        fileToBase64(file).then((base64) => {
            const req = {
                name: "Payment Request",
                document: [
                    {
                        name: file.name,
                        type: file.type,
                        base64: base64,
                    },
                ],
            };

            API.post("imageUpload/add", req)
                .then((res) => {
                    setPaymentImageUrl(res.data.url?.[0]);
                })
                .catch((err) => {
                    console.error("Payment image upload error", err);
                })
                .finally(() => {
                    setLoading(false);
                });
        });
    };

    const getCustomerEmail = (customer, languageId) => {
        if (!customer) return "";
        return languageId === 1
            ? customer.Email
            : customer["E-mail"];
    };

    const getCustomerName = (customer, languageId) => {
        if (!customer) return "";
        return languageId === 1
            ? customer["Full Name"]
            : customer["Nom et prénom"];
    };

    const sendPaymentRequest = () => {
        const errors = {};

        if (!paymentMessage) {
            errors.message =
                languageId === 1
                    ? "Message is required"
                    : "Le message est requis";
        }

        if (!paymentImageUrl) {
            errors.image =
                languageId === 1
                    ? "Please upload image"
                    : "Veuillez télécharger une image";
        }

        if (Object.keys(errors).length > 0) {
            setPaymentErrors(errors);
            return;
        }

        setPaymentErrors({});

        const payload = {
            consultation_booking_id: admin.consultation_booking_id,
            message: paymentMessage,
            image: paymentImageUrl,
            email: getCustomerEmail(admin.customer, languageId),
            full_name: getCustomerName(admin.customer, languageId),
        };

        API.post("paymentRequestFormAdd/add", payload).then((res) => {
            if (res.data.success) {
                resetPopupFormData();
                setPopupbutton({ show: false });
                setPopup({
                    show: true,
                    title: languageId === 1 ? "Success" : "Succès",
                    message:
                        languageId === 1
                            ? "Payment request sent successfully"
                            : "Demande de paiement envoyée avec succès",
                    navigate: false,
                });
            }
        });
    };

    const handleConfirmPayment = () => {
        const errors = {};

        if (!appointmentAmount) {
            errors.amount =
                languageId === 1
                    ? "Please enter appointment amount"
                    : "Veuillez entrer le montant du rendez-vous";
        }

        if (!amountReceived) {
            errors.amountReceived =
                languageId === 1
                    ? "Please confirm that the appointment amount is received"
                    : "Veuillez confirmer que le montant du rendez-vous est reçu";
        }

        if (Object.keys(errors).length > 0) {
            setBookingErrors(errors);
            return;
        }

        setBookingErrors({});
        setLoading(true); // 🔹 START LOADING

        const payload = {
            amount: appointmentAmount,
            payment_request_form_id: "",
            consultation_booking_id: admin.consultation_booking_id,
            email: getCustomerEmail(admin.customer, languageId),
            full_name: getCustomerName(admin.customer, languageId),
        };

        API.post("paymentRequestAmountStatusUpdate/update", payload).then((res) => {
            if (res.data.success) {
                resetPopupFormData();
                setPopupbutton({ show: false });
                setPopup({
                    show: true,
                    title: languageId === 1 ? "Success" : "Succès",
                    message:
                        languageId === 1
                            ? "Payment confirmed successfully"
                            : "Paiement confirmé avec succès",
                    navigate: false,
                });
            }
        })
            .catch(() => {
                // optional error popup
            })
            .finally(() => {
                setLoading(false); // 🔹 STOP LOADING
            });
    };

    const totalAppointmentAmount = Array.isArray(admin?.paymentrequest)
        ? admin.paymentrequest.reduce((sum, item) => {
            const amount = Number(item.amount) || 0;
            return sum + amount;
        }, 0)
        : 0;
    const visiblePaymentRequests = Array.isArray(admin?.paymentrequest)
        ? admin.paymentrequest.filter(
            (p) => p.message || p.image
        )
        : [];
    useEffect(() => {
        if (popupbutton.show) {
            resetPopupFormData();
        }
    }, [popupbutton.show]);
    const handleNote = () => {
        setNotesText("");
        setNotesError("");
        setShowNotesPopup(true);
    };

    const submitNotes = () => {
        if (!notesText.trim()) {
            setNotesError(
                languageId === 1
                    ? "Notes are required"
                    : "Les notes sont requises"
            );
            return;
        }

        const payload = {
            consultation_booking_id: admin.consultation_booking_id,
            notes: notesText,
        };

        API.post("consultationNotesAdd/add", payload)
            .then((res) => {
                if (res.data.success) {
                    setShowNotesPopup(false);
                    setNotesText("");

                    handleNotesList();

                    setPopup({
                        show: true,
                        type: "success",
                        title: languageId === 1 ? "Success" : "Succès",
                        message:
                            languageId === 1
                                ? "Notes added successfully"
                                : "Notes ajoutées avec succès",
                        navigate: false,
                    });
                }
            })
            .catch((err) => {
                console.error("Notes error:", err);
            });
    };


    const handleNotesList = () => {
        setNotesListLoading(true);

        const payload = {
            consultation_booking_id: admin.consultation_booking_id,
        };

        API.post("consultationNotesList/condition", payload)
            .then((res) => {
                if (res.data.success) {
                    setNotesList(res.data.data || []);
                }
            })
            .catch((err) => {
                console.error("Notes list error:", err);
            })
            .finally(() => {
                setNotesListLoading(false);
            });
    };


    useEffect(() => {
        if (admin?.consultation_booking_id) {
            handleNotesList();
        }
    }, [admin?.consultation_booking_id]);

    const formatNoteDate = (date) => {
        const formattedDate = format(new Date(date), "MMMM d");
        const timeAgo = formatDistanceStrict(new Date(date), new Date(), {
            addSuffix: true,
        });

        return `${formattedDate} · ${timeAgo}`;
    };
    return (
        <div className="con-view-form-container">
            {/* ================= STEP 1 ================= */}
            {step === 1 && (
                <div className="con-form-container">
                    <div className="newsadd-header">
                        <h2 className="newsadd-title">
                            {languageId === 1 ? "Edit Consultation" : "Modifier la consultation"}
                        </h2>
                        <div className="header-buttons">
                            <button
                                className="cancel-btn"
                                onClick={() =>
                                    navigate("/ConsultationFromList", { state: { pageNumber } })
                                }
                            >
                                {languageId === 1 ? "Back" : "Retour"}
                            </button>
                        </div>
                    </div>

                    <div className="intake-form">

                        {/* IMMIGRATION GOAL */}
                        <div className="form-group">
                            <label>
                                {languageId === 1
                                    ? "Select your immigration goal"
                                    : "Sélectionnez votre objectif d'immigration"}
                            </label>
                            <select
                                className="form-select"
                                value={immigrationvalue}
                                onChange={Immigration}
                            >
                                <option value="">
                                    {languageId === 1 ? "-- Select --" : "-- Sélectionner --"}
                                </option>
                                {Array.isArray(listimmigratongoal) &&
                                    listimmigratongoal.map((item) => (
                                        <option key={item.listofservice_id} value={item.listofservice_id}>
                                            {item.heading}
                                        </option>
                                    ))}
                            </select>
                            {immigrationErr && <p className="text-danger">{immigrationErr}</p>}
                        </div>

                        {/* CONSULTATION TYPE */}
                        <div className="form-group mt-3">
                            <label>
                                {languageId === 1 ? "Consultation Type" : "Type de consultation"}
                            </label>
                            <select
                                className="form-select"
                                value={hadleType}
                                onChange={handleConsultationType}
                            >
                                <option value="">
                                    {languageId === 1 ? "-- Select --" : "-- Sélectionner --"}
                                </option>
                                {Array.isArray(consultationtype) &&
                                    consultationtype.map((item) => (
                                        <option
                                            key={item.consultation_type_id}
                                            value={item.consultation_type_id}
                                        >
                                            {item.consultation_type_name}
                                        </option>
                                    ))}
                            </select>
                            {consultationErr && <p className="text-danger">{consultationErr}</p>}
                        </div>

                        {/* DATE */}
                        <div className="mt-4">
                            <p className="scheduledateandtime">
                                {languageId === 1 ? "Schedule Date" : "Date du rendez-vous"}
                            </p>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateCalendar
                                    value={startDate}
                                    onChange={handleDateChange}
                                    views={["day"]}
                                    sx={calendarStyles}
                                    disablePast
                                />

                            </LocalizationProvider>
                        </div>

                        {/* TIME SLOTS */}
                        <div className="mt-3">
                            {timeList.length > 0 && (
                                <p className="time mt-2">{languageId === 1 ? "Time" : "Heure"}</p>
                            )}
                            <div className="d-flex flex-wrap gap-3 col-lg-6">
                                {timeList.map((item, index) => {
                                    const disabled = isSlotDisabled(item.start_time, item.end_time);

                                    return (
                                        <div
                                            key={index}
                                            className={`card p-2 timebagroundcolour
                  ${activeStartTime &&
                                                    normalizeTime(activeStartTime) === normalizeTime(item.start_time)
                                                    ? "active-time"
                                                    : disabled
                                                        ? "disabled-time"
                                                        : "cursorpointer"
                                                }`}
                                            onClick={() => {
                                                if (!disabled) handleStartTime(item);
                                            }}
                                        >
                                            {formatTime(item.start_time)}
                                        </div>
                                    );
                                })}
                            </div>

                            {!startTime && <div className="text-danger mt-1">Please select a time slot</div>}
                        </div>

                        {/* NEXT BUTTON */}
                        <div className="next-buttons">
                            <button
                                type="button"
                                className="cancel-btn"
                                // onClick={() => {
                                //     if (startTime) setStep(2);
                                // }}
                                onClick={handleNextStep}
                            >
                                {languageId === 1 ? "Next" : "Suivant"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ================= STEP 2 ================= */}
            {step === 2 && (
                <>
                    <div className="intake-header">
                        <h2>{languageId === 1 ? "IMMIGRATION CONSULTATION INTAKE FORM" : "FORMULAIRE DE DEMANDE DE CONSULTATION EN MATIÈRE D'IMMIGRATION"}</h2>

                        <button className="cancel-btn" onClick={() => setStep(1)}>
                            {languageId === 1 ? "Back" : "Retour"}
                        </button>
                    </div>
                    <div className=" mt-3 mb-4 d-flex justify-content-end">
                        {amountStatus !== "Paid" && (
                            <button
                                className="cancel-btn me-2"
                                onClick={() =>
                                    setPopupbutton({
                                        show: true,
                                        type: "payment",
                                        title: "Payment Request",
                                        message: "Please complete the payment to continue.",
                                    })
                                }
                            >
                                {languageId === 1 ? "Payment Request" : "Demande de paiement"}
                            </button>
                        )}
                        <button className="cancel-btn" onClick={() => setPopupbutton({
                            show: true,
                            type: "booking",
                            title: "Booking Confirmation",
                            message: "Confirm booking after payment is received."
                        })
                        }
                        >
                            {languageId === 1 ? "Booking Confirmation" : "Confirmation de réservation"}
                        </button>
                    </div>
                    <div class="card rounded-3 immigrationgap shadow-sm">
                        <div class="card-body">
                            <div className='row mt-3 '>
                                <p className='personalinformation mt-3 mb-3'>
                                    {languageId === 1 ? "Personal Information" : "Informations personnelles"}
                                </p>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    {Array.isArray(personalinformation) && personalinformation.length > 0 &&
                                        personalinformation.map((item) => {
                                            const label = normalize(item.label);
                                            const inputType = normalize(item.input_type);

                                            const isDOB =
                                                label.includes("date de naissance") ||
                                                label.includes("date of birth");

                                            const isMaritalStatus =
                                                label.includes("etat civil") || label.includes("marital");


                                            const isMobileNumber =
                                                inputType.includes("mobile_number") ||
                                                inputType.includes("numero_de_portable");


                                            const isEmail =
                                                label.includes("e-mail") ||
                                                label.includes("email");

                                            const isPreferredLanguage =
                                                label.includes("langue preferee") ||
                                                label.includes("preferred language");

                                            const isNumberOfChildren =
                                                label.includes("nombre d'enfants") ||
                                                inputType.includes("number_of_children");

                                            const isCountryOfCitizenship =
                                                label.includes("pays de citoyennete") ||
                                                inputType.includes("country_of_citizenship");


                                            const isCountryOfResidency =
                                                label.includes("pays de residence") ||
                                                inputType.includes("country_of_residency");


                                            return (
                                                <div key={item.personal_information_id} className="mb-3 col-lg-6">
                                                    <label className="form-label labelinput">
                                                        {item.label}
                                                        <span className="text-danger ms-1">*</span>
                                                    </label>
                                                    {isDOB ? (
                                                        <>
                                                            <DatePicker
                                                                value={
                                                                    personalInformationValues[item.personal_information_id]
                                                                        ? dayjs(personalInformationValues[item.personal_information_id])
                                                                        : null
                                                                }
                                                                onChange={(newValue) =>
                                                                    handlePersonalInformation(
                                                                        item.personal_information_id,
                                                                        newValue ? newValue.format("YYYY-MM-DD") : ""
                                                                    )
                                                                }
                                                                maxDate={dayjs()}
                                                                slotProps={{
                                                                    textField: {
                                                                        fullWidth: true,
                                                                        size: "small",
                                                                        error: Boolean(
                                                                            personalInformationErr[item.personal_information_id]
                                                                        ),
                                                                        placeholder: item.placeholder || "Select date",
                                                                        className: "form-control inputclssname",
                                                                        InputProps: {
                                                                            style: {
                                                                                height: "44px",
                                                                            },
                                                                        },
                                                                    },
                                                                }}
                                                            />
                                                            {personalInformationErr[item.personal_information_id] && (
                                                                <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                    {personalInformationErr[item.personal_information_id]}
                                                                </div>
                                                            )}
                                                        </>
                                                    ) :
                                                        isNumberOfChildren ? (
                                                            <>
                                                                <select
                                                                    className={`form-select inputclssname ${personalInformationErr[item.personal_information_id] ? "is-invalid" : ""
                                                                        }`}
                                                                    value={
                                                                        personalInformationValues[item.personal_information_id] ?? ""
                                                                    }
                                                                    onChange={(e) =>
                                                                        handlePersonalInformation(
                                                                            item.personal_information_id,
                                                                            Number(e.target.value)
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="">
                                                                        {languageId === 1 ? "Select number of children" : "Sélectionnez le nombre d'enfants"}
                                                                    </option>

                                                                    {[0, 1, 2, 3, 4, 5].map((num) => (
                                                                        <option key={num} value={num}>
                                                                            {num}
                                                                        </option>
                                                                    ))}

                                                                </select>
                                                                {personalInformationErr[item.personal_information_id] && (
                                                                    <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                        {personalInformationErr[item.personal_information_id]}
                                                                    </div>
                                                                )}
                                                            </>
                                                        )
                                                            : isPreferredLanguage ? (
                                                                <>
                                                                    <select
                                                                        className={`form-select inputclssname ${personalInformationErr[item.personal_information_id]
                                                                            ? "is-invalid"
                                                                            : ""
                                                                            }`}
                                                                        value={
                                                                            personalInformationValues[item.personal_information_id] || ""
                                                                        }
                                                                        onChange={(e) =>
                                                                            handlePersonalInformation(
                                                                                item.personal_information_id,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        <option value="">
                                                                            {languageId === 1
                                                                                ? "Select preferred language"
                                                                                : "Sélectionnez la langue préférée"}
                                                                        </option>                                                                        {Array.isArray(preferedlanguage) &&
                                                                            preferedlanguage.map((lang) => (
                                                                                <option
                                                                                    key={lang.languages}
                                                                                    value={lang.languages}
                                                                                >
                                                                                    {lang.languages}
                                                                                </option>
                                                                            ))}
                                                                    </select>
                                                                    {personalInformationErr[item.personal_information_id] && (
                                                                        <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                            {personalInformationErr[item.personal_information_id]}
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) :
                                                                isCountryOfResidency ? (
                                                                    <select
                                                                        className={`form-select inputclssname ${personalInformationErr[item.personal_information_id] ? "is-invalid" : ""}`}
                                                                        value={personalInformationValues[item.personal_information_id] || ""}
                                                                        onChange={(e) => {
                                                                            const selectedCountry = countryDropDown.find(
                                                                                (c) => c.country_name === e.target.value
                                                                            );
                                                                            const rawCode =
                                                                                selectedCountry?.dial_code ??
                                                                                selectedCountry?.country_code ??
                                                                                "";
                                                                            const formattedCode = rawCode.startsWith("+") ? rawCode : `+${rawCode}`;

                                                                            setCountryCode(formattedCode);
                                                                            handlePersonalInformation(
                                                                                item.personal_information_id,
                                                                                e.target.value
                                                                            );

                                                                            if (mobileNumber) {
                                                                                const mobileItem = personalinformation.find(p => {
                                                                                    const type = normalize(p.input_type);
                                                                                    return (
                                                                                        type.includes("mobile") ||
                                                                                        type.includes("numero_de_portable")
                                                                                    );
                                                                                });

                                                                                if (mobileItem) {
                                                                                    handlePersonalInformation(
                                                                                        mobileItem.personal_information_id,
                                                                                        `${formattedCode}${mobileNumber}`
                                                                                    );
                                                                                }
                                                                            }

                                                                        }}

                                                                    >
                                                                        <option value="">Select country</option>
                                                                        {countryDropDown.map((country) => (
                                                                            <option key={country.country_name} value={country.country_name}>
                                                                                {country.country_name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                ) :
                                                                    isMobileNumber ? (
                                                                        <>
                                                                            <div className="input-group">
                                                                                <select
                                                                                    className="form-select inputclssname"
                                                                                    value={countryCode}
                                                                                    onChange={(e) => {
                                                                                        setCountryCode(e.target.value);

                                                                                        handlePersonalInformation(
                                                                                            item.personal_information_id,
                                                                                            `${e.target.value}${mobileNumber}`,
                                                                                            "mobile"
                                                                                        );
                                                                                    }}
                                                                                    style={{
                                                                                        width: "150px",
                                                                                        flex: "0 0 auto"
                                                                                    }}
                                                                                >
                                                                                    {countryCode && (
                                                                                        <option value={countryCode}>
                                                                                            {countryCode}
                                                                                        </option>
                                                                                    )}

                                                                                    {countryDropDown.map((country) => {
                                                                                        const code = country.dial_code || country.country_code || "";
                                                                                        const formattedCode = code.startsWith("+") ? code : `+${code}`;

                                                                                        return (
                                                                                            <option
                                                                                                key={country.country_name}
                                                                                                value={formattedCode}
                                                                                            >
                                                                                                {formattedCode} ({country.country_name})
                                                                                            </option>
                                                                                        );
                                                                                    })}
                                                                                </select>
                                                                                <input
                                                                                    type="text"
                                                                                    inputMode="numeric"
                                                                                    maxLength={10}
                                                                                    className={`form-control inputclssname ${personalInformationErr[item.personal_information_id] ? "is-invalid" : ""
                                                                                        }`}
                                                                                    value={mobileNumber}
                                                                                    onChange={(e) => {
                                                                                        const numbersOnly = e.target.value.replace(/\D/g, "");
                                                                                        setMobileNumber(numbersOnly);
                                                                                        handlePersonalInformation(
                                                                                            item.personal_information_id,
                                                                                            `${countryCode}${numbersOnly}`,
                                                                                            "mobile"
                                                                                        );
                                                                                    }}
                                                                                    placeholder="Enter mobile number"
                                                                                />
                                                                            </div>
                                                                            {personalInformationErr[item.personal_information_id] && (
                                                                                <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                                    {personalInformationErr[item.personal_information_id]}
                                                                                </div>
                                                                            )}
                                                                        </>
                                                                    )
                                                                        :
                                                                        isCountryOfCitizenship ? (
                                                                            <select
                                                                                className={`form-select inputclssname ${personalInformationErr[item.personal_information_id] ? "is-invalid" : ""}`}
                                                                                value={personalInformationValues[item.personal_information_id] || ""}
                                                                                onChange={(e) => {

                                                                                    handlePersonalInformation(item.personal_information_id, e.target.value);
                                                                                }}
                                                                            >
                                                                                <option value="">Select country</option>
                                                                                {countryDropDown.map((country) => (
                                                                                    <option key={country.country_name} value={country.country_name}>
                                                                                        {country.country_name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        ) :
                                                                            isEmail ? (
                                                                                <>
                                                                                    <input
                                                                                        type="email"
                                                                                        className={`form-control inputclssname ${personalInformationErr[item.personal_information_id]
                                                                                            ? "is-invalid"
                                                                                            : ""
                                                                                            }`}
                                                                                        value={
                                                                                            personalInformationValues[item.personal_information_id] || ""
                                                                                        }
                                                                                        onChange={(e) =>
                                                                                            handlePersonalInformation(
                                                                                                item.personal_information_id,
                                                                                                e.target.value
                                                                                            )
                                                                                        }
                                                                                        placeholder="Enter email address"
                                                                                    />
                                                                                    {personalInformationErr[item.personal_information_id] && (
                                                                                        <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                                            {personalInformationErr[item.personal_information_id]}
                                                                                        </div>
                                                                                    )}
                                                                                </>
                                                                            )
                                                                                : isMaritalStatus ? (
                                                                                    <>
                                                                                        <select
                                                                                            className={`form-select inputclssname ${personalInformationErr[item.personal_information_id] ? "is-invalid" : ""
                                                                                                }`}
                                                                                            value={personalInformationValues[item.personal_information_id] || ""}
                                                                                            onChange={(e) =>
                                                                                                handlePersonalInformation(item.personal_information_id, e.target.value)
                                                                                            }
                                                                                        >
                                                                                            <option value="">
                                                                                                {languageId === 1
                                                                                                    ? "Select marital status"
                                                                                                    : "Sélectionnez l’état civil"}
                                                                                            </option>

                                                                                            {languageId === 1 ? (
                                                                                                <>
                                                                                                    <option value="Married">Married</option>
                                                                                                    <option value="Unmarried">Unmarried</option>
                                                                                                </>
                                                                                            ) : (
                                                                                                <>
                                                                                                    <option value="Marié(e)">Marié(e)</option>
                                                                                                    <option value="Célibataire">Célibataire</option>
                                                                                                </>
                                                                                            )}
                                                                                        </select>


                                                                                        {personalInformationErr[item.personal_information_id] && (
                                                                                            <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                                                {personalInformationErr[item.personal_information_id]}
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <input
                                                                                            type="text"
                                                                                            className={`form-control inputclssname ${personalInformationErr[item.personal_information_id]
                                                                                                ? "is-invalid"
                                                                                                : ""
                                                                                                }`}
                                                                                            value={
                                                                                                personalInformationValues[item.personal_information_id] || ""
                                                                                            }
                                                                                            onChange={(e) =>
                                                                                                handlePersonalInformation(
                                                                                                    item.personal_information_id,
                                                                                                    e.target.value
                                                                                                )
                                                                                            }
                                                                                            placeholder={item.placeholder}
                                                                                        />
                                                                                        {personalInformationErr[item.personal_information_id] && (
                                                                                            <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                                                {personalInformationErr[item.personal_information_id]}
                                                                                            </div>
                                                                                        )}
                                                                                    </>
                                                                                )}
                                                </div>
                                            );
                                        })}
                                </LocalizationProvider>
                                <div className='mt-1 mb-3'>
                                    <p className='personalinformation mt-3'>
                                        {languageId === 1 ? "Background Information" : "Informations générales"}
                                    </p>
                                </div>
                                {Array.isArray(bagroundinformation) &&
                                    bagroundinformation.length > 0 &&
                                    bagroundinformation.map((item) => {
                                        const label = normalize(item.label); // lowercase, trimmed

                                        const isPrimaryImmigration = [
                                            "what is your primary for immigration to canada?",
                                            "quel est votre principal motif d'immigration au canada ?"
                                        ].some(l => normalize(l) === label);

                                        const isTimeline = [
                                            "what timeline are you targeting?",
                                            "quel est votre objectif en termes de calendrier ?"
                                        ].some(l => normalize(l) === label);

                                        const isSpouse = [
                                            "will your spouse /children accompany you?",
                                            "votre conjoint(e)/vos enfants vous accompagneront-ils ?"
                                        ].some(l => normalize(l) === label);

                                        const isImmigrationType = [
                                            "are you seeking temporary or permanent immigration?",
                                            "recherchez-vous une immigration temporaire ou permanente ?"
                                        ].some(l => normalize(l) === label);


                                        return (
                                            <div key={item.background_information_id} className="mb-3 col-lg-6">
                                                <label className="form-label labelinput">
                                                    {item.label}
                                                    {!isTimeline && <span className="text-danger ms-1">*</span>}
                                                </label>
                                                {/* PRIMARY IMMIGRATION (BACKEND DROPDOWN) */}
                                                {isPrimaryImmigration ? (
                                                    <select
                                                        className={`form-select inputclssname ${bagroundInformationErr[item.background_information_id]
                                                            ? "is-invalid"
                                                            : ""
                                                            }`}
                                                        value={
                                                            bagroundinformationvalues[item.background_information_id] || ""
                                                        }
                                                        onChange={(e) =>
                                                            handleBagroundInformation(
                                                                item.background_information_id,
                                                                e.target.value
                                                            )
                                                        }
                                                    >
                                                        <option value="">
                                                            {languageId === 1 ? "Select option" : "Sélectionnez une option"}
                                                        </option>

                                                        {Array.isArray(bgDropdownData[item.background_information_id]) &&
                                                            bgDropdownData[item.background_information_id].map((opt) => (
                                                                <option
                                                                    key={opt.background_information_data_id}
                                                                    value={opt.value}
                                                                >
                                                                    {languageId === 1 ? opt.value : opt.value_fr || opt.value}
                                                                </option>
                                                            ))}

                                                    </select>
                                                )
                                                    /* TIMELINE */
                                                    : isTimeline ? (
                                                        <select
                                                            className={`form-select inputclssname ${bagroundInformationErr[item.background_information_id]
                                                                ? "is-invalid"
                                                                : ""
                                                                }`}
                                                            value={
                                                                bagroundinformationvalues[item.background_information_id] || ""
                                                            }
                                                            onChange={(e) =>
                                                                handleBagroundInformation(
                                                                    item.background_information_id,
                                                                    e.target.value
                                                                )
                                                            }
                                                        >
                                                            <option value="">
                                                                {languageId === 1 ? "Select timeline" : "Sélectionnez le calendrier"}
                                                            </option>

                                                            {[0, 1, 2, 3, 4, 5].map((year) => {
                                                                const value =
                                                                    languageId === 1 ? `${year} year` : `${year} an(s)`;

                                                                return (
                                                                    <option key={year} value={value}>
                                                                        {value}
                                                                    </option>
                                                                );
                                                            })}


                                                        </select>
                                                    )
                                                        /* SPOUSE */
                                                        : isSpouse ? (
                                                            <select
                                                                className={`form-select inputclssname ${bagroundInformationErr[item.background_information_id]
                                                                    ? "is-invalid"
                                                                    : ""
                                                                    }`}
                                                                value={
                                                                    bagroundinformationvalues[item.background_information_id] || ""
                                                                }
                                                                onChange={(e) =>
                                                                    handleBagroundInformation(
                                                                        item.background_information_id,
                                                                        e.target.value
                                                                    )
                                                                }
                                                            >
                                                                <option value="">
                                                                    {languageId === 1 ? "Select option" : "Sélectionnez une option"}
                                                                </option>

                                                                <option value={languageId === 1 ? "Yes" : "Oui"}>
                                                                    {languageId === 1 ? "Yes" : "Oui"}
                                                                </option>

                                                                <option value={languageId === 1 ? "No" : "Non"}>
                                                                    {languageId === 1 ? "No" : "Non"}
                                                                </option>



                                                            </select>
                                                        )
                                                            /* IMMIGRATION TYPE */
                                                            : isImmigrationType ? (
                                                                <select
                                                                    className={`form-select inputclssname ${bagroundInformationErr[item.background_information_id]
                                                                        ? "is-invalid"
                                                                        : ""
                                                                        }`}
                                                                    value={
                                                                        bagroundinformationvalues[item.background_information_id] || ""
                                                                    }
                                                                    onChange={(e) =>
                                                                        handleBagroundInformation(
                                                                            item.background_information_id,
                                                                            e.target.value
                                                                        )
                                                                    }
                                                                >
                                                                    <option value="">
                                                                        {languageId === 1 ? "Select type" : "Sélectionnez le type"}
                                                                    </option>

                                                                    <option value={languageId === 1 ? "Temporary" : "Temporaire"}>
                                                                        {languageId === 1 ? "Temporary" : "Temporaire"}
                                                                    </option>

                                                                    <option value={languageId === 1 ? "Permanent" : "Permanent"}>
                                                                        {languageId === 1 ? "Permanent" : "Permanent"}
                                                                    </option>


                                                                </select>
                                                            )
                                                                /* DEFAULT */
                                                                : (
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control inputclssname ${bagroundInformationErr[item.background_information_id]
                                                                            ? "is-invalid"
                                                                            : ""
                                                                            }`}
                                                                        value={
                                                                            bagroundinformationvalues[item.background_information_id] || ""
                                                                        }
                                                                        placeholder={item.placeholder}
                                                                        onChange={(e) =>
                                                                            handleBagroundInformation(
                                                                                item.background_information_id,
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    />
                                                                )}
                                                {bagroundInformationErr[item.background_information_id] && (
                                                    <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                        {bagroundInformationErr[item.background_information_id]}
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                <div className='mt-3'>
                                    <p className='personalinformation mt-3'>
                                        {languageId === 1 ? "Supporting Document Upload" : "Téléchargement des documents justificatifs"}
                                    </p>
                                </div>
                                {Array.isArray(documentupload) &&
                                    documentupload.map((item) => {
                                        const files = uploadedFiles[item.document_upload_id] || [];
                                        return (
                                            <div
                                                key={item.document_upload_id}
                                                className="col-12 col-lg-6 mt-2"
                                            >
                                                <label className="form-label labelinput">
                                                    {item.label}
                                                </label>

                                                <div
                                                    className="file-upload-box text-center p-3"
                                                    onDragOver={handleDragOver}
                                                    onDrop={(e) =>
                                                        handleDrop(item.document_upload_id, e)
                                                    }
                                                >
                                                    <label
                                                        htmlFor={`fileUpload-${item.document_upload_id}`}
                                                        className="icon-rectangle"
                                                    >
                                                        <input
                                                            type="file"
                                                            multiple
                                                            id={`fileUpload-${item.document_upload_id}`}
                                                            style={{ display: "none" }}
                                                            onChange={(e) =>
                                                                handleFileChange(item.document_upload_id, e)
                                                            }
                                                        />
                                                        <img src={UploadIcon} alt="upload" />
                                                    </label>

                                                    <div className="upload-instructions mt-2">
                                                        <p className="mb-1 inputclssname">
                                                            {languageId === 1
                                                                ? "Drop your files here or click to upload"
                                                                : "Déposez vos fichiers ici ou cliquez pour téléverser"}
                                                        </p>
                                                    </div>


                                                    {files.map((fileData, index) => (
                                                        <div
                                                            key={index}
                                                            className="uploaded-content mt-3"
                                                            style={{ position: "relative" }}
                                                        >
                                                            {/* DOWNLOAD */}
                                                            <div className="doc-action-icons">
                                                                <img
                                                                    src={Download}
                                                                    alt="Download"
                                                                    className="action-icon download-icon"
                                                                    onClick={() => downloadDocument(fileData)}
                                                                />
                                                                <img
                                                                    src={Delete}
                                                                    alt="Delete"
                                                                    className="action-icon delete-icon"
                                                                    onClick={() =>
                                                                        removeDocument(item.document_upload_id, index)
                                                                    }
                                                                />
                                                            </div>
                                                            {fileData.type?.startsWith("image/") && (
                                                                <img
                                                                    src={fileData.preview}
                                                                    className="document-image-preview"
                                                                    alt="preview"
                                                                />
                                                            )}
                                                            {fileData.type === "application/pdf" && (
                                                                <embed
                                                                    src={fileData.preview}
                                                                    type="application/pdf"
                                                                    className="document-pdf-preview"
                                                                />
                                                            )}


                                                            {fileData.type === "text/plain" && (
                                                                <iframe
                                                                    src={fileData.preview}
                                                                    className="document-text-preview"
                                                                    title="text-preview"
                                                                />
                                                            )}

                                                            {[
                                                                "application/msword",
                                                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                                                "application/vnd.ms-excel",
                                                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                                            ].includes(fileData.type) && (
                                                                    <div className="document-file-name">
                                                                        📄 {fileData.name}
                                                                    </div>
                                                                )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    })}
                                <div className='mt-3 mb-3'>
                                    <p className='personalinformation mt-3'>
                                        {languageId === 1 ? "Payment Information" : "Informations de paiement"}
                                    </p>
                                </div>
                                {Array.isArray(paymentinformation) &&
                                    paymentinformation.length > 0 &&
                                    paymentinformation.map((item) => {
                                        const labelNormalized = normalize(item.label);
                                        const isWhichCountry = labelNormalized.includes("de quel pays") || labelNormalized.includes("which country");

                                        return (
                                            <div key={item.payment_information_id} className="mb-3 col-lg-6">
                                                <label className="form-label labelinput">
                                                    {item.label}
                                                </label>

                                                {isWhichCountry ? (
                                                    <>
                                                        <select
                                                            className={`form-select inputclssname ${paymentInformationErr[item.payment_information_id] ? "is-invalid" : ""}`}
                                                            value={paymentInformationValues[item.payment_information_id] || ""}
                                                            onChange={(e) =>
                                                                handlePaymentInformation(item.payment_information_id, e.target.value)
                                                            }
                                                        >
                                                            <option value="">Select country</option>
                                                            {countryDropDown.map((country) => (
                                                                <option key={country.country_id || country.country_name} value={country.country_name}>
                                                                    {country.country_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {paymentInformationErr[item.payment_information_id] && (
                                                            <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                                {paymentInformationErr[item.payment_information_id]}
                                                            </div>
                                                        )}
                                                    </>
                                                ) : (
                                                    <input
                                                        type="text"
                                                        className={`form-control inputclssname ${paymentInformationErr[item.payment_information_id] ? "is-invalid" : ""}`}
                                                        value={paymentInformationValues[item.payment_information_id] || ""}
                                                        onChange={(e) =>
                                                            handlePaymentInformation(item.payment_information_id, e.target.value)
                                                        }
                                                        placeholder={item.placeholder}
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                <div className="d-flex justify-content-between mt-3">
                                    <div className="labelinput"></div>
                                    <div className="col-12 col-lg-4 mt-2">
                                        <label className="form-label labelinput">
                                            {languageId === 1 ? "Signature (digital)" : "Signature (numérique)"}
                                        </label>
                                        <div
                                            className="file-upload-box text-center p-3"
                                            onDragOver={(e) => e.preventDefault()}
                                            onDragEnter={(e) => e.preventDefault()}
                                            onDrop={(e) => {
                                                e.preventDefault();
                                                const file = e.dataTransfer.files[0];
                                                handleSignatureUpload({ target: { files: [file] } });
                                            }}
                                        >
                                            <label htmlFor="signatureUpload" className="icon-rectangle">
                                                <input
                                                    type="file"
                                                    id="signatureUpload"
                                                    ref={signatureInputRef}
                                                    style={{ display: "none" }}
                                                    onChange={handleSignatureUpload}
                                                    accept="
                image/png,
                image/jpeg,
                image/svg+xml,
                image/gif,
                application/pdf,
                text/plain,
                application/msword,
                application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                application/vnd.ms-excel,
                application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
            "
                                                />
                                                <img src={UploadIcon} alt="upload" />
                                            </label>

                                            <div className="upload-instructions mt-2">
                                                <p className="mb-1 inputclssname">
                                                    {languageId === 1
                                                        ? "Drop your files here or click to upload"
                                                        : "Déposez vos fichiers ici ou cliquez pour téléverser"}
                                                </p>
                                            </div>

                                            {signaturePreview &&
                                                signaturePreview !== "null" && (
                                                    <div className="uploaded-content mt-3" style={{ position: "relative" }}>
                                                        <div className="doc-action-icons">
                                                            <img
                                                                src={Download}
                                                                alt="Download"
                                                                className="action-icon download-icon"
                                                                onClick={downloadSignature}
                                                            />
                                                            <img
                                                                src={Delete}
                                                                alt="Delete"
                                                                className="action-icon delete-icon"
                                                                onClick={removeSignature}
                                                            />
                                                        </div>
                                                        {signatureType?.startsWith("image/") && (
                                                            <img
                                                                src={signaturePreview}
                                                                alt="Signature"
                                                                className="document-image-preview"
                                                            />
                                                        )}
                                                        {signatureType === "application/pdf" && (
                                                            <embed
                                                                src={signaturePreview}
                                                                className="document-pdf-preview"
                                                                title="Signature PDF"
                                                            />
                                                        )}

                                                        {signatureType === "text/plain" && (
                                                            <iframe
                                                                src={signaturePreview}
                                                                className="document-text-preview"
                                                                title="Signature Text"
                                                            />
                                                        )}

                                                    </div>
                                                )}
                                        </div>

                                    </div>
                                </div>
                                <div className="d-flex justify-content-end mt-4 mb-2">
                                    <button className="bookconsultationcontinue py-3 px-5" type="button" onClick={handleUpdateConsultation}>{languageId === 1 ? "Submit" : "Soumettre"}</button>
                                </div>

                                {visiblePaymentRequests.length > 0 && (
                                    <>
                                        <div className="mt-3 mb-3">
                                            <p className="personalinformation mt-3">
                                                {languageId === 1
                                                    ? "Payment Request Form"
                                                    : "Formulaire de demande de paiement"}
                                            </p>
                                        </div>

                                        {visiblePaymentRequests.map((payment) => (
                                            <div
                                                key={payment.payment_request_form_id}
                                                className="popup-grid1 mb-3"
                                            >
                                                <div>
                                                    <label className="form-label">
                                                        {languageId === 1 ? "Message" : "Message"}
                                                    </label>
                                                    <textarea
                                                        value={payment.message || ""}
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-12 col-lg-12">
                                                    <label className="form-label labelinput d-block">
                                                        {languageId === 1 ? "QR Code" : "Code QR"}
                                                    </label>

                                                    {payment.image && (
                                                        <div className="mt-2">
                                                            <img
                                                                src={payment.image}
                                                                alt="QR"
                                                                style={{
                                                                    maxHeight: "120px",
                                                                    objectFit: "contain",
                                                                }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </>
                                )}


                                {Array.isArray(admin?.paymentrequest) &&
                                    admin.paymentrequest.length > 0 && (
                                        <>
                                            <div className="mt-3 mb-3">
                                                <p className="personalinformation mt-3">
                                                    {languageId === 1
                                                        ? "Booking Confirmation"
                                                        : "Confirmation de rendez-vous"}
                                                </p>
                                            </div>

                                            <div className="booking-content">
                                                <div className="form-group">
                                                    <label className="form-label">
                                                        {languageId === 1
                                                            ? "Appointment Amount"
                                                            : "Montant du rendez-vous"}
                                                    </label>

                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={`$ ${totalAppointmentAmount}`}
                                                        readOnly
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}

                                <>
                                    <div className="mt-3 mb-3">
                                        <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                                            <p className="personalinformation mb-0">
                                                {languageId === 1 ? "Notes" : "Remarques"}
                                            </p>

                                            <button
                                                className="cancel-btn"
                                                type="button"
                                                onClick={handleNote}
                                            >
                                                {languageId === 1 ? "Notes" : "Remarques"}
                                            </button>
                                        </div>
                                        {notesListLoading ? (
                                            <p>{languageId === 1 ? "Loading..." : "Chargement..."}</p>
                                        ) : notesList.length > 0 ? (
                                            <ul className="list-group">
                                                {notesList.map((note) => (
                                                    <li
                                                        key={note.consultation_notes_id}
                                                        className="list-group-item justify-content-between align-items-start"
                                                    >
                                                        <div className="flex-grow-1 me-3">
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor={`note-${note.consultation_notes_id}`}
                                                            >
                                                                {note.notes}
                                                            </label>
                                                        </div>
                                                        <div className="text-muted">
                                                            {formatNoteDate(note.createdAt)}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>


                                        ) : (
                                            <p className="no-faq-text">
                                                {languageId === 1 ? "No notes found" : "Aucune note trouvée"}
                                            </p>
                                        )}
                                    </div>

                                </>


                                <div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
            {popup.show && (
                <div className="popup-overlay">
                    <div className={`popup-box popup-${popup.type}`}>
                        <h3>{popup.title}</h3>
                        <p>{popup.message}</p>

                        <div className="popup-buttons">
                            <button
                                className="btn ok-btn"
                                onClick={() => {
                                    setPopup({ show: false });

                                    if (popup.type === "success") {
                                        navigate("/ConsultationFromList", {
                                            state: { pageNumber },
                                        });
                                    }
                                }}
                            >
                                OK
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* note popup */}
            {showNotesPopup && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <h5 className="mb-3">
                            {languageId === 1 ? "Add Notes" : "Ajouter des notes"}
                        </h5>

                        <textarea
                            className="form-control"
                            rows="4"
                            value={notesText}
                            placeholder={
                                languageId === 1
                                    ? "Enter notes here"
                                    : "Entrez les notes ici"
                            }
                            onChange={(e) => {
                                setNotesText(e.target.value);
                                setNotesError("");
                            }}
                        />

                        {notesError && (
                            <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                {notesError}
                            </div>
                        )}

                        <div className="d-flex justify-content-end gap-2 mt-3">
                            <button
                                class="send-btn"
                                onClick={() => setShowNotesPopup(false)}
                            >
                                {languageId === 1 ? "Cancel" : "Annuler"}
                            </button>

                            <button
                                class="send-btn"
                                onClick={submitNotes}

                            >
                                {languageId === 1
                                    ? "Save"
                                    : "Enregistrement"
                                }
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {popupbutton.show && (
                <div className="popup-overlay1">
                    <div className={`popup-box1 ${loading ? "popup-loading" : ""}`}>

                        {/* PAYMENT POPUP */}
                        {loading ? (
                            <div className="loader-wrapper">
                                <Loading />
                            </div>
                        ) : (
                            <>
                                {/* PAYMENT POPUP */}
                                {popupbutton.type === "payment" && (
                                    <>
                                        <div>
                                            <h3>
                                                {languageId === 1 ? "Payment Request Form" : "Formulaire de demande de paiement"}
                                            </h3>

                                            <div className="popup-grid1">
                                                <div>
                                                    <label className="form-label">
                                                        {languageId === 1 ? "Message" : "Message"}
                                                        <span className="text-danger ms-1">*</span>
                                                    </label>
                                                    <textarea
                                                        placeholder={
                                                            languageId === 1
                                                                ? "Enter your message here"
                                                                : "Entrez votre message ici"
                                                        }
                                                        value={paymentMessage}
                                                        onChange={(e) => {
                                                            setPaymentMessage(e.target.value);
                                                            setPaymentErrors((prev) => ({ ...prev, message: "" }));
                                                        }}
                                                    />

                                                    {paymentErrors.message && (
                                                        <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                            {paymentErrors.message}
                                                        </div>
                                                    )}

                                                </div>

                                                <div className="col-12 col-lg-12">
                                                    <label className="form-label labelinput">
                                                        {languageId === 1 ? "Upload QR code" : "Télécharger le code QR"}
                                                        <span className="text-danger ms-1">*</span>
                                                    </label>
                                                    <div className="file-upload-box text-center p-3">
                                                        <label>
                                                            <input
                                                                type="file"
                                                                style={{ display: "none" }}
                                                                onChange={handlePaymentImageUpload}
                                                            />

                                                            {paymentImagePreview ? (
                                                                <img
                                                                    src={paymentImagePreview}
                                                                    alt="Uploaded"
                                                                    style={{ maxHeight: "100px", objectFit: "contain" }}
                                                                />
                                                            ) : (
                                                                <img src={UploadIcon} alt="upload" />
                                                            )}
                                                        </label>
                                                        <div className="upload-instructions mt-2">
                                                            <p className="mb-1 inputclssname">
                                                                {languageId === 1 ? "Click to upload" : "Cliquez pour télécharger"}
                                                            </p>
                                                        </div>
                                                    </div>
                                                    {paymentErrors.image && (
                                                        <div className="text-danger mt-2" style={{ fontSize: "0.85rem" }}>
                                                            {paymentErrors.image}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            <button className="send-btn" onClick={sendPaymentRequest}>
                                                {languageId === 1 ? "Send" : "Envoyer"}
                                            </button>
                                        </div>
                                    </>
                                )}
                                {/* BOOKING POPUP */}
                                {popupbutton.type === "booking" && (
                                    <>
                                        <div className="Booking">
                                            <h3>
                                                {languageId === 1
                                                    ? "Booking Confirmation"
                                                    : "Confirmation de rendez-vous"}
                                            </h3>

                                            <div className="booking-content">
                                                <div className="form-group">
                                                    <label className="form-label">
                                                        {languageId === 1
                                                            ? "Appointment Amount"
                                                            : "Montant du rendez-vous"}
                                                        <span className="text-danger ms-1">*</span>
                                                    </label>

                                                    <input
                                                        type="text"
                                                        className={`form-control ${bookingErrors.amount ? "is-invalid" : ""
                                                            }`}
                                                        placeholder="$"
                                                        value={appointmentAmount}
                                                        onChange={(e) => {
                                                            setAppointmentAmount(e.target.value);
                                                            setBookingErrors((prev) => ({
                                                                ...prev,
                                                                amount: "",
                                                            }));
                                                        }}
                                                    />

                                                    {bookingErrors.amount && (
                                                        <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                            {bookingErrors.amount}
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="checkbox booking-checkbox">
                                                    <div className="checkbox-label">
                                                        <input
                                                            type="checkbox"
                                                            id="amountReceived"
                                                            checked={amountReceived}
                                                            onChange={(e) => {
                                                                setAmountReceived(e.target.checked);
                                                                setBookingErrors((prev) => ({
                                                                    ...prev,
                                                                    amountReceived: "",
                                                                }));
                                                            }}
                                                        />
                                                        <label htmlFor="amountReceived">
                                                            {languageId === 1
                                                                ? "Appointment Amount Received "
                                                                : "Montant du rendez-vous reçu "}
                                                        </label>
                                                    </div>

                                                    <span className="text-danger">*</span>
                                                </div>


                                                {bookingErrors.amountReceived && (
                                                    <div className="text-danger mt-1" style={{ fontSize: "0.85rem" }}>
                                                        {bookingErrors.amountReceived}
                                                    </div>
                                                )}
                                            </div>

                                            <button
                                                className="send-btn"
                                                onClick={handleConfirmPayment}
                                                disabled={loading}
                                            >
                                                {languageId === 1 ? "Confirm" : "Confirmer"}
                                            </button>
                                        </div>
                                    </>
                                )}
                            </>
                        )}


                        {/* CLOSE BUTTON */}
                        <button
                            className="close-btn"
                            onClick={() => {
                                resetPopupFormData();
                                setPopupbutton({ ...popupbutton, show: false });
                            }}
                        >
                            ✕
                        </button>
                    </div>
                </div>
            )}



        </div>
    );
};

export default ConsultationEdit;